button.fp-button(data-test='button' :disabled='disabled || loading' :class='{"-expand": expand, "-secondary": secondary, "-no-border": noBorder}' :type='type')
  span.fp-button--icon(data-test='button.icon' v-if='icon || loading')
    i.fp-icon.-s16(:class='iconClasses()')
  | {{ text }}
